import './OrderTypeSelector.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import Tabs from 'devextreme-react/tabs';
import { useMemo } from 'react';
import { useAuth } from '../../../../contexts/auth';
import { useGetCompany } from '../../../../api/company';
import { InstallerType } from '../../../../types/enums';

export default function OrderTypeSelector() {

    const { user } = useAuth();
    const company = useGetCompany(user?.companyId);

    const isCFI = company.data?.installerTypes.includes(InstallerType.CFI);

    let navigate = useNavigate();

    let tabs = useMemo(() => {
        var result =
            [
                { text: "Retail Orders", url: "/cfi/orders/retail-orders" }
            ];

        if (company.data?.productLines.find(x => x.productLineCode === 'Small Projects')) {
            result.push({ text: "Vanity Orders", url: "/cfi/orders/vanity-orders" });
        }

        if (isCFI) {
            result.push({ text: "Material Orders", url: "/cfi/orders/material-orders" });
        }

        result.push({ text: "Work Orders", url: "/cfi/orders/work-orders" });

        if (isCFI) {
            result.push({ text: "Back Orders", url: "/cfi/orders/back-orders" });
        }

        if (company.data?.SFI) {
            result.push({ text: "Leads", url: "/cfi/orders/leads" });
        }

        if (isCFI) {
            result.push({ text: "Estimates", url: "/cfi/orders/estimates" });
        }

        return result;
    }, [company.data]);

    const location = useLocation();
    const currentPath = (location.pathname === '/cfi/orders') ? '/cfi/orders/retail-orders' : location.pathname;
    const selectedIndex = tabs.findIndex(x => currentPath.includes(x.url));

    return (
        <Tabs
            className='cfi-order-type-selector'
            items={tabs}
            selectedIndex={selectedIndex}
            onItemClick={(e) => {
                if (e.itemData) {
                    navigate(e.itemData?.url);
                }
            }}
        />
    )
}

